// extracted by mini-css-extract-plugin
module.exports = {"block":"block_block__zBKCu"};